import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import {
  getAssetType,
  getBreeds,
  getFactions,
  getPosts,
  getSalesType,
  getSearch,
} from "../../redux";
import { useDispatch, useSelector } from "react-redux";
import Styles from "./Home.module.sass";
import cn from "classnames";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Row, Col, Input } from "antd";
import { Link, useParams } from "react-router-dom";
import Modal from "../../components/Modal";
import { useSnackbar } from "notistack";
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import {
  getErrorMessage,
  injected,
  useEagerConnect,
  useInactiveListener,
} from "../../utils/connections";
import HomeCarousel from "../../components/HomeCarousel";
import HomeLeaderboard from "../../components/HomeLeaderBoard";
import DogBg from "../../images/dogbg.png";
import PlanetAsset from "../../images/planetAsset.png";
import NewModal from "../../components/NewModal";
import SpaceshipMint from "../../components/SpaceshipMint";
import { isMobile } from "react-device-detect";
import Breeding from "./Breeding";
import Race from "./Race";
import LotteryLeaderBoard from "./Lottery";
import LotteryScreen from "./LotteryScreen";
import Shooter from "./Shooter";
import Community from "./Community";
import Cyberdogz from "./Cyberdogz";
import Stake from "./Stake";
import Stock from "./Stock";
import LandOwner from "./LandOwner";
import Rent from "./Rent";
import Winners from "./Winners";
import NewsUpdates from "./News&Updates";
import Dashboard from "./Dashboard";
const Home = ({ history }) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [isSelectWallet, setIsSelectWallet] = useState(false);
  const [showWarningBanner, setShowWarningBanner] = useState(false);
  const { account, active, activate, error, deactivate } = useWeb3React();
  const [value, setValue] = useState(0);
  const [spaceshipModal, setSpaceshipModal] = useState(false);
  const triedEager = useEagerConnect();
  useInactiveListener(!triedEager);

  useEffect(() => {
    if (error) {
      enqueueSnackbar(getErrorMessage(error), { variant: "error" });
    }
  }, [error]);
  useEffect(() => {
    if (error) {
      if (error instanceof UnsupportedChainIdError) {
        setShowWarningBanner(true);
      }
      enqueueSnackbar(getErrorMessage(error), { variant: "error" });
    }
  }, [error]);
  useEffect(() => {
    if (active) {
      setShowWarningBanner(false);
    }
  }, [active]);

  useEffect(() => {
    dispatch(getBreeds());
    dispatch(getFactions());
    dispatch(getAssetType());
    dispatch(getSearch());
    dispatch(getSalesType());
  }, []);

  useEffect(() => {
    getUSDCurrency();
  }, [state.Usd.USD]);
  const getUSDCurrency = () => {
    if (state.Usd.USD.length) {
      let usd = state.Usd.USD.find((element) => {
        return element.chainName == "ETH";
      });
      if (usd) setValue(usd.price);
    }
  };

  return (
    <div className={Styles.homeContainer}>
      <div className={Styles.bg}>
        <Shooter />
        {/* <Dashboard /> */}
        {/* <LotteryScreen /> */}
        {/* <Race /> */}
        <Cyberdogz />
        <div className={Styles.shadowBg}>
          <br />
          <br />
          <Community />

          <br />
          <br />

          <Stake />
        </div>
        <div className={Styles.winnersBg}>
          <br />
          <br />
          <Winners />
          <br />
          <br />
        </div>
        <Stock />
        <br />
        <br />

        <LandOwner />
        <br />
        <br />
        <NewsUpdates />
        <br />
        <br />
        <Rent />
        {/* <LotteryLeaderBoard /> */}
        {/* <div className={Styles.content}>
        <LandOwner />
        <NewsUpdates />
        <Rent />
        <Stock />
        <LotteryLeaderBoard />
        <div className={Styles.content}>
          <img src={DogBg} className={Styles.dogbg} />
          <div className={Styles.container}>
            <div className={Styles.stake_container}>
              <div className={Styles.stake_body}>
                <div className={Styles.stake_head}>
                  <div className={Styles.stake_text}>STAKE,</div>
                  {/* <div className={Styles.stake_text_mob}> <li>STAKE</li></div> 

                  <div className={Styles.levelup_text}>TRAIN</div>
                  <div className={Styles.stake_text}>AND</div>
                  <div className={Styles.bonez_text}>EARN</div>
                </div>
                <div className={Styles.stakescreen}>
                  <div className={Styles.stake_para}>
                    Race your CYBERDOGZ to victory and build your legendary
                    status today.
                  </div>
                  <div className={Styles.startButtondiv}>
                    <Link to={"/marketplace"} className={Styles.startButton}>
                      START
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={Styles.stake_mob_screen}>
          <div className={Styles.stake_para}>
            Race your CYBERDOGZ to victory and build your legendary status
            today.
          </div>
          <div className={Styles.startButtondiv}>
            <Link to={"/marketplace"} className={Styles.startButton}>
              START
            </Link>
          </div>
        </div>

        <div className={Styles.asset}>
          <div className={Styles.kibblezText}>
            Prepare for galactic battles, stake your CYBERDOGZ, yield{" "}
            <span className={Styles.kibblez}>$KIBBLEZ</span>
            <br />
            and build your army using multichain
            <br />
            NFT's and DeFi.
          </div>
          <HomeCarousel />
          <div className={Styles.buttondiv}>
            <Link to={"/marketplace"} className={Styles.button}>
              Visit Marketplace
            </Link>
          </div>
        </div>

        <div className={Styles.banner}>
          <marquee>
            <p>
              STAKE YOUR DOGZ! &emsp; &emsp; &emsp; THE INVASION IS LIVE. STAKE
              YOUR DOGZ! &emsp; &emsp; &emsp; THE INVASION IS LIVE.
            </p>
          </marquee>
        </div>
        <div className={Styles.buttondiv}>
          <a
            target="_blank"
            href={
              "https://info.uniswap.org/#/polygon/tokens/0xcf79651fbae99559127764a5ab808747fa3391ce"
            }
            className={Styles.button}
          >
            View BONEZ / MATIC
          </a>
        </div>
        <div className={Styles.kibblezText}>
          <span className={Styles.kibblez}>Disclaimer: </span>
          $BONEZ are not a financial asset. $BONEZ are <br />
          in-game tokens and hold no value. $BONEZ are in Beta.
          <br /> Use at your own risk.
        </div>

        <div className={Styles.container}>
          <HomeLeaderboard />
        </div>
        <div className={Styles.planet}>
          <img src={PlanetAsset} className={Styles.planetImg} />
          <div className={Styles.palnet_text}>
            Planet Earth was coming to an end. Professor Corso
            <br />
            developed advanced cybernetic dogs with
            <br />
            neurolinking technologies
            <br />
            called <b>CYBERDOGZ.</b>
          </div>
        </div>
        <Breeding />
        <Modal
          visible={isSelectWallet}
          onClose={() => setIsSelectWallet(false)}
        >
          <div className={Styles.modal}>
            <div className={Styles.wallethead}>Connect Wallet</div>
            <br />
            <div className={Styles.walletText}>
              Please connect your wallet to continue.
              <br /> The system supports the following wallets
              <br />
              <br />
            </div>
            <div
              className={Styles.wallet}
              onClick={() => {
                if (isMobile && !window.ethereum) {
                  window.location =
                    "https://metamask.app.link/dapp/cyberdogz.io";
                } else {
                  activate(injected);
                  setIsSelectWallet(false);
                }
              }}
            >
              <img
                className={Styles.metamask}
                src="data:image/svg+xml;base64,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"
              />
              MetaMask
              <img
                className={Styles.iconimg}
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjAyMTUgOC42NDVMMTUuMzY0OCAxNEwxMC4wMjE1IDE5LjM1NUwxMS42NjY1IDIxTDE4LjY2NjUgMTRMMTEuNjY2NSA3TDEwLjAyMTUgOC42NDVaIiBmaWxsPSIjNzc3RTkwIi8+Cjwvc3ZnPgo="
              />
            </div>
          </div>
        </Modal>
        <NewModal
          visible={spaceshipModal}
          outerClassName={Styles.mintModal}
          onClose={() => setSpaceshipModal(false)}
        >
          <SpaceshipMint value={value} />
        </NewModal> */}
      </div>
    </div>
  );
};

export default Home;
